import { CheckRounded } from "@mui/icons-material";
import DashCard from "./DashCard";

const WEEKDAY = {
  0: "Mon",
  1: "Tue",
  2: "Wed",
  3: "Thu",
  4: "Fri",
  5: "Sat",
  6: "Sun",
};

const WeekDayItem = ({ index, value }) => {
  return (
    <div className="day-item">
      <>
        <div className={`check ${value}`}>
          <CheckRounded
            color={value ? "green" : "iconGray"}
            fontSize="inherit"
          />
        </div>
        <small>{WEEKDAY[index]}</small>
      </>
    </div>
  );
};

const WeeklyCard = ({ weeklyActivity, loading }) => {
  return (
    <DashCard
      title="Weekly Activity"
      cornerContent={
        weeklyActivity.streak_total ? (
          <p className="mb-0 gradient-text">
            {weeklyActivity.streak_total} Day Streak!
          </p>
        ) : null
      }
      children={
        <div className="weekly-container">
          {weeklyActivity.days.map((day, index) => {
            return (
              <WeekDayItem
                index={index}
                loading={loading}
                value={day}
                key={`day-${WEEKDAY[index]}`}
              />
            );
          })}
        </div>
      }
    />
  );
};

export default WeeklyCard;
